import axios from 'axios';
import getConfig from 'next/config';
import { getKeycloakInstance } from '@react-keycloak-fork/ssr';

const { publicRuntimeConfig } = getConfig();
const request = axios.create({ baseURL: publicRuntimeConfig.apiUrl });
const anonymousRequest = axios.create({ baseURL: publicRuntimeConfig.apiUrl });

request.interceptors.request.use(async config => {
    const { token } = getKeycloakInstance();
    config.headers.Authorization = `Bearer ${token}`; // eslint-disable-line no-param-reassign
    return config;
});

export async function sendTellAFriendMail({ name, friendName, friendEmail, message }) {
    await anonymousRequest.post('/email/tell-a-friend', { name, friendName, friendEmail, message });
}

export async function signupForDTUExperiment({ name, email }) {
    await anonymousRequest.post('/email/signup', { email, topic: 'dtu-forskningsprojekt', context: { name } });
}

export async function signupForThePenlyPanel({ name, email }) {
    await anonymousRequest.post('/email/signup', { email, topic: 'penly-panel', context: { name } });
}

export async function emailTestAll() {
    await request.post('/email/testAll');
}

export async function signupForInvestTjekEmailNotification(email) {
    await request.post('/email/signup', { email });
}

export async function contactMe({ firstName, lastName, email, phone, affiliateId, product }) {
    await anonymousRequest.post('/email/contact-me', { name: `${firstName} ${lastName}`, email, phone, affiliateId, product });
}

export async function contactPenly({ email, emails, subject, data }) {
    await anonymousRequest.post('/email/contact-penly', { email, emails, subject, data });
}

export async function contactRequestFromKrifa(data) {
    await anonymousRequest.post('/email/contact-request-krifa', data);
}
